/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
  document.addEventListener('DOMContentLoaded', () => {
    const tabsDrawer = document.querySelector('[data-tabs-drawer]');
    const tabsOverlay = document.querySelector('[data-tabs-drawer-overlay]');

    if (!tabsDrawer) return;

    const tabLinks = document.querySelectorAll('.tab-link');
    const tabContents = tabsDrawer.querySelectorAll('.tab-content-drawer');
    const productContentContainer = document.querySelector('.product__content');

    console.log(productContentContainer.getBoundingClientRect());

    tabContents.forEach((content, index) => {
      content.style.width = `${productContentContainer.getBoundingClientRect().width + 32}px`;
    });

    // Event delegation for tab links
    tabsDrawer.addEventListener('click', (e) => {
      const tabLink = e.target.closest('.tab-link');
      if (!tabLink) return;
      console.log(tabLink);

      e.preventDefault();

      const tabNum = tabLink.dataset.tab;
      const tabContent = tabsDrawer.querySelector(`.tab-content-${tabNum}`);

      if (!tabContent) return;

      // Remove 'current' class from all tab links and contents
      tabLinks.forEach((link) => link.classList.remove('current'));
      tabContents.forEach((content) => content.classList.remove('current'));

      // Add 'current' class to the clicked tab link and corresponding content
      document.querySelectorAll(`.tab-link-${tabNum}`).forEach((tabLink) => tabLink.classList.add('current'));
      tabContent.classList.add('current');
      tabsOverlay.classList.add('is-visible');
    });

    tabsOverlay.addEventListener('click', () => {
      tabsOverlay.classList.remove('is-visible');
      tabLinks.forEach((link) => link.classList.remove('current'));
      tabContents.forEach((content) => content.classList.remove('current'));
    });
  });

  // Brand Story Tabs

  document.addEventListener('DOMContentLoaded', () => {
    const tabTargets = document.querySelector('[data-tab-targets]');

    if (!tabTargets) return;

    tabTargets.addEventListener('click', (e) => {
      const target = e.target;
      const targetId = target.dataset.targetId;

      if (!target) return;

      document.querySelectorAll('.brick__target').forEach((content) => content.classList.remove('current'));
      target.classList.add('current');

      const tabContent = document.querySelector(`[data-tab-content-id="${targetId}"]`);
      const tabImage = document.querySelector(`[data-tab-image-id="${targetId}"]`);

      if (!tabContent) return;

      const tabContents = document.querySelectorAll('.brick__block--text');
      const tabImages = document.querySelectorAll('.brick__block--tab-image');

      tabContents.forEach((content) => content.classList.remove('current'));
      tabImages.forEach((image) => image.classList.remove('current'));
      tabContent.classList.add('current');
      tabImage.classList.add('current');
    });
  });
})();
